var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Pagefy.length!=0)?_c('div',{staticClass:"f-z"},[_c('div',{staticClass:"paging1",on:{"click":function($event){return _vm.paging(1)}}},[_vm._v("上一页")]),_c('div',{staticClass:"paging2"},[_vm._v(_vm._s(_vm.Page2))]),_c('div',{staticClass:"paging1",on:{"click":function($event){return _vm.paging(2)}}},[_vm._v("下一页")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }